import { Component, } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import('quill')

import { BaseComponent } from './core/components/base.component';
import { TranslationService } from './core/services/translate.service';
import { TranslationModule } from './shared/modules/translate/translate.module';
import { ThemeService } from './core/services/theme.service';
import { TooltipService } from './shared/directives/tooltip/tooltip.service';
import { LocalStorage } from './core/helpers/localstorage.helper';
import { TimeagoModule } from 'ngx-timeago';
import { BrandingService } from './modules/admin/pages/system-theme/branding.service';
import { AppDataService } from './core/services/app-data.service';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'epmax-root',
    imports: [TranslationModule, RouterOutlet, TimeagoModule],
    providers: [ThemeService],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent extends BaseComponent {

    constructor(
        private tooltipService: TooltipService, private translationService: TranslationService, private themeService: ThemeService,
        private brandingSvc: BrandingService, private configService: AppDataService,
        private titleService: Title) {
        super();
        (document as any).loginByExternalToken = (auth: any, isDarkMode: boolean, lang: 'ar' | 'en') => {
            localStorage.setItem("auth", auth);
            LocalStorage.set('isDarkMode', isDarkMode);
            LocalStorage.set('lang', lang);
            location.reload();
        };

         (document as any).setDarkMode = ( isDarkMode: boolean) => {
            this.themeService.toggleDarkMode(isDarkMode)
        };        

        (document as any).setAutomationIdClass = () => { document.documentElement.classList.add('automation-mode'); }
        const appTitle = LocalStorage.get('lang') == 'ar' ? this.configService.brandingSettings.systemName.textAr : this.configService.brandingSettings.systemName.textEn;
        this.titleService.setTitle(appTitle);


    }

    protected override ngSuperOnInit() {
        this.tooltipService.loadTooltip();
        this.loadTranslation();
       
        this.themeService.toggleDarkMode();
        LocalStorage.set('url', document.location.href.replace(document.baseURI, '/'), true);
        LocalStorage.set('tabId', Math.floor(Math.random() * 9999999) + 1, true);
        
        this.brandingSvc.generateRootTheme(this.configService.brandingSettings.baseColor, this.configService.brandingSettings.systemFontValue)
               
    }
    protected override ngSuperAfterViewInit() {    

    }
    protected override ngSuperOnDestroy() {

    }

    loadTranslation() {
        this.translationService.setLang(LocalStorage.get('lang') as 'ar' | 'en');
    }
 
}
